var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureTopHospital = function SvgFeatureTopHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.75 4.75a.75.75 0 0 1 .75.75V8A.75.75 0 0 1 11 8V5.5a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M9.75 6.75A.75.75 0 0 1 10.5 6H13a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7 6.75a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M8.75 15.5a.25.25 0 0 0-.25.25V21H15v-5.25a.25.25 0 0 0-.25-.25zM7 15.75c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-.75.75h-8a.75.75 0 0 1-.75-.75zM2.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13A.75.75 0 0 1 2.75 8M20.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M2.75 6.5a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h5.537a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 7.75v-1C1 5.784 1.784 5 2.75 5h5.128a.75.75 0 0 1 0 1.5H2.75M14.873 5.75a.75.75 0 0 1 .75-.75h5.127c.966 0 1.75.784 1.75 1.75v1a1.75 1.75 0 0 1-1.75 1.75h-5.536a.75.75 0 1 1 0-1.5h5.536a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-5.127a.75.75 0 0 1-.75-.75M1 21.75a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5h-20a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.75 14a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureTopHospital;